/* eslint-disable react/prop-types */
import React from 'react';
import { _IconButton } from "./styles";
export function NavigationIcon(props) {
  var Icon = props.Icon,
    targetPage = props.targetPage,
    goToPage = props.goToPage;
  function onClick() {
    goToPage(targetPage);
  }
  return /*#__PURE__*/React.createElement(_IconButton, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Icon, null));
}